import React, { useState } from "react";

const MicrocertsTable = ({ microcerts }) => {
  const [visibleRecords, setVisibleRecords] = useState(5); // Tracks the number of records visible
  const [searchQuery, setSearchQuery] = useState(""); // Tracks the search query

  // Filter records based on search query
  const filteredMicrocerts = microcerts?.filter(
    (cert) =>
      cert.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      cert.trackTitle.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Load more records in increments of 5
  const handleLoadMore = () => {
    setVisibleRecords((prev) => prev + 5);
  };

  return (
    <div className="seanalytics-table-container">
      {/* Search Bar */}
      <div className="search-bar-an mb-4">
        <input
          type="text"
          placeholder="Search Microcert Name or Track"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="form-control"
        />
      </div>

      {/* Table */}
      <div className="seanalytics-table-responsive">
        <table className="seanalytics-table seanalytics-table-bordered">
          <thead>
            <tr>
              <th>Microcerts Name</th>
              <th>Track</th>
              <th className="status-column">Status</th>
              
            </tr>
          </thead>
          <tbody>
            {filteredMicrocerts?.slice(0, visibleRecords).map((cert, index) => (
              <tr key={index}>
                <td>{cert.title}</td>
                <td>{cert.trackTitle}</td>
                <td>
                  <span
                    className={`seanalytics-badge ${
                      cert.status === "Completed"
                        ? "seanalytics-bg-success"
                        : cert.status === "Not Completed"
                        ? "seanalytics-bg-warning"
                        : "seanalytics-bg-info"
                    }`}
                  >
                    {cert.status}
                  </span>
                </td>
              </tr>
            ))}
            {filteredMicrocerts?.length === 0 && (
              <tr>
                <td colSpan="3" className="text-center">
                  No results found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Load More Button */}
      {visibleRecords < filteredMicrocerts?.length && (
        <div className="text-center mt-4">
          <button
            onClick={handleLoadMore}
            className="bytton-load-more"
          >
            Load More
          </button>
        </div>
      )}
    </div>
  );
};

export default MicrocertsTable;
